query GetPrimaryContactsForAccount(
  $id: ID!
  $first: Int
  $last: Int
  $after: String
  $before: String
  $query: String
  $queryList: [QueryItemInput!]
) {
  primaryContactsForAccount(
    accountId: $id
    first: $first
    last: $last
    after: $after
    before: $before
    query: $query
    queryList: $queryList
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    edges {
      node {
        id
        firstName
        lastName
        email
        phoneNumber
        title
        mobilePhoneNumber
        label

        insertedAt
        updatedAt

        account {
          id
        }
      }
    }
  }
}
